import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  Validator,
  ValidationErrors
} from '@angular/forms';

@Directive({
  selector: '[appMinDate]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MinDateDirective,
      multi: true,
    },
  ],
})
export class MinDateDirective implements Validator, OnChanges {

  @Input('appMinDate') config!: {
    minDate: string | Date | null | undefined;
  };

  private control!: AbstractControl;
  private onValidatorChange?: () => void;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config']) {
      this.setMinDate();

      if (this.control) {
        this.control.updateValueAndValidity({ emitEvent: false });
      }

      if (this.onValidatorChange) {
        this.onValidatorChange();
      }
    }
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  private formatDateToISO(date: string | Date): string {
    const inputDate = new Date(date);
    return inputDate.toISOString().split('T')[0];
  }

  private setMinDate(): void {
    if (this.config?.minDate) {
      const formattedMinDate = this.formatDateToISO(this.config.minDate);

      this.renderer.setAttribute(
        this.el.nativeElement,
        'min',
        formattedMinDate
      );
    } else {
      this.renderer.removeAttribute(
        this.el.nativeElement,
        'min'
      );
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    this.control = control;

    if (!control.value || !this.config?.minDate) {
      return null;
    }

    const inputDate = new Date(control.value);
    const minDate = new Date(this.config.minDate);

    return inputDate.getTime() < minDate.getTime()
      ? {
          minDate: {
            requiredDate: this.config.minDate,
            actualDate: control.value
          }
        }
      : null;
  }

  @HostListener('blur')
  onBlur(): void {
    if (!this.control?.value || !this.config?.minDate) {
      return;
    }

    const inputDate = new Date(this.control.value);
    const minDate = new Date(this.config.minDate);

    if (inputDate.getTime() < minDate.getTime()) {
      this.clearInput();
    }
  }

  private clearInput(): void {
    this.control.setValue(null);
    this.renderer.setProperty(
      this.el.nativeElement,
      'value',
      ''
    );
  }
}